// R-131-OVERVIEW-UX-C
import type { BugReport, BugReportSeverity, BugSeverity } from '../../types/bugReport';

export type IssueSeverityDisplay = 'Low' | 'Medium' | 'High' | 'Blocking';

export const ISSUE_SEVERITY_COLORS: Record<IssueSeverityDisplay, string> = {
  Low: 'bg-zinc-500/20 text-zinc-300',
  Medium: 'bg-amber-500/20 text-amber-300',
  High: 'bg-orange-500/20 text-orange-300',
  Blocking: 'bg-red-500/20 text-red-300',
};

export function resolveIssueSeverity(
  report: Pick<BugReport, 'auditSeverity' | 'severity'>,
): IssueSeverityDisplay {
  const audit = report.auditSeverity;
  if (audit === 'block') return 'Blocking';
  if (audit === 'info') return 'Low';
  if (audit === 'warn') return 'Medium';

  const legacy = report.severity as BugReportSeverity;
  if (legacy === 'CRITICAL') return 'Blocking';
  if (legacy === 'SUGGESTION') return 'Low';
  return 'Medium';
}

export function issueSeverityToAudit(severity: IssueSeverityDisplay): BugSeverity {
  if (severity === 'Blocking') return 'block';
  if (severity === 'Low') return 'info';
  return 'warn';
}

export function issueSeverityToLegacy(severity: IssueSeverityDisplay): BugReportSeverity {
  if (severity === 'Blocking') return 'CRITICAL';
  if (severity === 'Low') return 'SUGGESTION';
  return 'STANDARD';
}
